module.exports = __webpack_public_path__ + "static/media/unlimited_svg.2ca4f901.svg";